import { PaymentStatusDto } from "services/organizationBranches/restModels";

export const PAGE_SIZE = 20;

export const SEARCH_DEBOUNCE_MS = 300;

// Адрес кабинета держит клиент: бэк отдаёт только токен, чтобы ссылка со стенда не вела в прод.
export const WAREHOUSE_URL = "https://my.restify.one/";

export const PAYMENT_STATUS_LABELS: Record<PaymentStatusDto, string> = {
    paid: "Оплачен",
    overdue: "Просрочен",
    expired: "Истёк",
};

// Пустое значение — обычная опция списка: «Любой» это осмысленный выбор, а не отсутствие ввода.
export const PAYMENT_STATUS_OPTIONS = [
    { value: "", label: "Любой" },
    { value: "paid", label: PAYMENT_STATUS_LABELS.paid },
    { value: "overdue", label: PAYMENT_STATUS_LABELS.overdue },
    { value: "expired", label: PAYMENT_STATUS_LABELS.expired },
];
